function checkButtonVisibility() {
  const button = document.querySelector('[data-button-target]');
  const nav = document.querySelector('.navigation_wrapper');
  if (!button || !nav) return;
  
  // Check button's position in viewport
  const rect = button.getBoundingClientRect();
  const isVisible = (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
  
  // Add/remove class based on visibility
  if (isVisible) {
    nav.classList.remove('navigation--hidden');
  } else {
    nav.classList.add('navigation--hidden');
  }
}

// On page load and scroll/resize events
window.addEventListener('scroll', checkButtonVisibility);
window.addEventListener('resize', checkButtonVisibility);
document.addEventListener('DOMContentLoaded', checkButtonVisibility);